// extracted by mini-css-extract-plugin
export var activeMenu = "br1-P";
export var headerM = "br1-Q";
export var lMHeader = "br1-I";
export var lMHeaderClose = "br1-O";
export var lMHeaderContainer = "br1-H";
export var lMHeaderLogo = "br1-J";
export var lMHeaderMenu = "br1-M";
export var lMHeaderRight = "br1-K";
export var lMHeaderRightImg = "br1-L";
export var mHeaderShow = "br1-N";
export var minWidthLimit = "br1-G";